import Vue from "vue";
import store from '@/store/index'


const checkPermission = (value: string[]): boolean => {


  if (value && value instanceof Array && value.length > 0) {
    const permissions = store.getters['user/permissions'] as string[]
    const permissionRoles = value
    const hasPermission = permissions.some(p => {
      return permissionRoles.includes(p)
    })
    console.log("[checkPermission]:", value, hasPermission)
    return hasPermission
  } else {
    console.error(`need roles! Like v-permission="['admin','editor']"`)
    return false
  }
}

const checkRole = (value: string[]): boolean => {
  if (value && Array.isArray(value) && value.length > 0) {
    const roles = store.getters['user/roles'] as string[];
    const permissionRoles = value
    const hasPermission = roles.some(p => {
      return permissionRoles.includes(p)
    })
    console.log("[checkRole]:", value, hasPermission)
    return hasPermission
  } else {
    console.error(`need roles! Like v-permission="['admin','editor']"`)
    return false
  }
}


export {
  checkPermission,
  checkRole
}
